<template>
  <div class="mask">
    <div class="box">
      <div class="flex">
        <img src="../assets/r2.png" class="img mb-3">
        <p class="title mb-3">快递内容收到提醒</p>
        <p class="subtitle mb-3">是否已经收到</p>
        <p class="content mb-3">{{ notes }}</p>
        <p class="subtitle mb-3">以上全部内容</p>
        <div class="btn-group">
          <button @click="handleDeny">否</button>
          <span class="spacer"></span>
          <button class="info" @click="handleApprove">是</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "DeliveryReminder",
    props:{
      notes:{
        type:String,
        required:true
      }
    },
    methods:{
      handleApprove(){
        this.$emit('approve');
      },
      handleDeny(){
        this.$emit('deny');
      }
    }
  }
</script>

<style scoped>
  .flex{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding:23px;
  }
  .img{
    width:97px;
    height: 84px;
  }
  .title{
    font-weight: bold;
    font-size: 20px;
  }
  .subtitle{
    font-size: 16px;
    color:#666;
  }
  .content{
    font-size: 16px;
  }
  .btn-group{
    display: flex;
    width:100%;
  }
  .btn-group .spacer{
    width:20px;
  }
  .btn-group button{
    flex:1;
  }
</style>